import { inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { PagedResponse } from '@core/models/models';

export abstract class BaseService<T> {
  protected readonly http = inject(HttpClient);
  protected abstract readonly endpoint: string;

  protected get baseUrl(): string {
    return `${environment.apiurl}/api/${this.endpoint}`;
  }

  private buildParams(params?: Record<string, unknown>): HttpParams {
    let hp = new HttpParams();
    if (!params) return hp;
    for (const [k, v] of Object.entries(params)) {
      if (v !== null && v !== undefined && v !== '') {
        hp = hp.set(k, String(v));
      }
    }
    return hp;
  }

  getAll(params?: Record<string, unknown>): Observable<PagedResponse<T>> {
    return this.http.get<PagedResponse<T>>(this.baseUrl, { params: this.buildParams(params) });
  }

  getById(id: number): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${id}`);
  }

  create(dto: Partial<T>): Observable<T> {
    return this.http.post<T>(this.baseUrl, dto);
  }

  update(id: number, dto: Partial<T>): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${id}`, dto ?? {});
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
